import { FormCheckbox } from '@/components/forms/form-checkbox';
import { FormMultiSelect } from '@/components/forms/form-multi-select';
import { useSchoolOptions } from '@/lib/api-call-hooks';
import { NonCoreUserRolesFormSchema } from '@/routes/_layout/users/-components/form-schema';
import { UseFormReturn } from 'react-hook-form';

/**
 * Manage non-core user roles (i.e. roles except for student, coach and air_admin)
 */
export function NonCoreUserRolesForm<T extends object>({
  form: rawForm,
}: {
  form: UseFormReturn<NonCoreUserRolesFormSchema & T>;
}) {
  const form = rawForm as unknown as UseFormReturn<NonCoreUserRolesFormSchema>;
  const schoolOptions = useSchoolOptions();
  // const orgOptions = useOrgOptions();
  // const isOrgAdmin = form.watch('isOrgAdmin');

  return (
    <>
      {/* <div className="col-span-2 space-y-2">
        <FormCheckbox form={form} name="isOrgAdmin" label="Is District Admin" />
        <FormMultiSelect
          form={form}
          label="District"
          name="adminOrgs"
          multipleSelectorProps={{
            options: orgOptions,
            disabled: !isOrgAdmin,
            placeholder: `Select districts the user is an admin for`,
          }}
        />
      </div> */}
      <div className="col-span-2 space-y-2">
        <FormCheckbox form={form} name="isSchoolAdmin" label="Is school admin" />
        <div className="col-span-2 space-y-2">
          {form.watch('isSchoolAdmin') && (
            <FormMultiSelect
              form={form}
              label="School"
              name="adminSchools"
              multipleSelectorProps={{
                options: schoolOptions,
                placeholder: 'Select a school for school admin user',
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}
